import { ServiceListItem } from './ServiceListItem.js';
import { FONT_FAMILY_VARIANTS } from '@/components/Typography/constants.js';
import { Heading } from '@/components/Typography/Heading.js';
import { styled } from '@/stitches/index.js';

export const ServiceListContainer = styled('ul', {
  [`${ServiceListItem}:last-of-type`]: {
    display: 'flex',
    width: '100%',
  },
});

export const StyledHeading = styled(Heading, {
  fontFamily: '$body',
  fontSize: '$32',
  fontWeight: 400,
  letterSpacing: 0,
  variants: {
    fontFamily: {
      ...FONT_FAMILY_VARIANTS,
      panchang: {
        '@bp0': {
          fontSize: '$20',
        },
        '@bp2': {
          fontSize: '$32',
        },
        '@bp4': {
          fontSize: '$40',
        },
      },
    },
  },
});
